import { render } from "./pagination-table.vue?vue&type=template&id=64329ccc&scoped=true"
import script from "./pagination-table.vue?vue&type=script&lang=js"
export * from "./pagination-table.vue?vue&type=script&lang=js"

import "./pagination-table.vue?vue&type=style&index=0&id=64329ccc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64329ccc"]])

export default __exports__